/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2021 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import React from "react";

import WaitView from "../WaitView";
import LiquidModeIframe from "../../components/LiquidModeIframe";
import styles from "./index.css";

const LiquidModeView = props => {
  const {
    isDocumentInLiquidMode,
    showWaitView,
    waitViewStyle,
    showLiquidModeIframe,
    liquidModeIframeSrc,
    liquidModeViewReadyCallback
  } = props;
  return (
    <div className={!isDocumentInLiquidMode ? styles.HideContainer : styles.ShowContainer}>
      {showWaitView && <WaitView style={waitViewStyle} />}
      {showLiquidModeIframe && <LiquidModeIframe src={liquidModeIframeSrc} onLoad={liquidModeViewReadyCallback} />}
    </div>
  );
};

export default LiquidModeView;
